import {takeEvery, call, put} from "redux-saga/effects";
import actionTypes from "_constants/actionTypes";
import {xcService} from "_services/xcService";

export default function* watcherProfile() {
  yield takeEvery(actionTypes.SAVE_NAME, saveName);
  yield takeEvery(actionTypes.SAVE_ITEM, saveItem);
  yield takeEvery(actionTypes.GET_ITEMS, getItem);
  yield takeEvery(actionTypes.GET_AVITEMS, getAvItem);
}

function* getAvItem(payload) {
  yield put({type: actionTypes.START_REQUEST});

  try {
    let apiEndpoint = "/v1/student/avatar/items";
    const res = yield call(
      () =>
        new Promise((resolve, reject) => {
          xcService.getToken(apiEndpoint, payload).then((response) => {
            resolve(response);
          });
        })
    );
    if (res.status === 200) {
      yield put({type: actionTypes.GET_AVITEMS_DATA, payload: res.data.data});
    } else {
      yield put({type: actionTypes.GET_AVITEMS_ERROR, payload: res.data});
    }
  } catch (e) {
    yield put({type: actionTypes.GET_AVITEMS_ERROR, payload: e});
  }
  yield put({type: actionTypes.END_REQUEST});
}
function* getItem(payload) {
  yield put({type: actionTypes.START_REQUEST});

  try {
    let apiEndpoint = "/v1/student/items";
    const res = yield call(
      () =>
        new Promise((resolve, reject) => {
          xcService.getToken(apiEndpoint, payload).then((response) => {
            resolve(response);
          });
        })
    );
    if (res.status === 200) {
      yield put({type: actionTypes.GET_ITEMS_DATA, payload: res.data.data});
    } else {
      yield put({type: actionTypes.GET_ITEMS_ERROR, payload: res.data});
    }
  } catch (e) {
    yield put({type: actionTypes.GET_ITEMS_ERROR, payload: e});
  }
  yield put({type: actionTypes.END_REQUEST});
}

function* saveItem({payload}) {
  const { groupName, callback } = payload;
  yield put({type: actionTypes.START_REQUEST});

  try {
    let apiEndpoint = "/v1/student/avatar";
    const res = yield call(
      () =>
        new Promise((resolve, reject) => {
          xcService.postToken(apiEndpoint, {groupName}).then((response) => {
            resolve(response);
          });
        })
    );
    if (res.status === 200) {
      yield put({ type: actionTypes.SAVE_ITEM_DATA, payload: res.data.data });
      if (callback) callback(res.data.message, res.data.data);
    } else {
      yield put({type: actionTypes.SAVE_ITEM_ERROR, payload: res.data});
    }
  } catch (e) {
    yield put({type: actionTypes.SAVE_ITEM_ERROR, payload: e});
  }
  yield put({type: actionTypes.CLEAR_SAVE_ITEM, payload: {data: "data"}});
  yield put({type: actionTypes.END_REQUEST});
}

function* saveName({payload}) {
  yield put({type: actionTypes.START_REQUEST});

  try {
    let apiEndpoint = "/v1/student/name";
    const res = yield call(
      () =>
        new Promise((resolve, reject) => {
          xcService.postToken(apiEndpoint, payload).then((response) => {
            resolve(response);
          });
        })
    );
    if (res.status === 200) {
      yield put({type: actionTypes.SAVE_NAME_DATA, payload: res.data.data});
    } else {
      yield put({type: actionTypes.SAVE_NAME_ERROR, payload: res.data});
    }
  } catch (e) {
    yield put({type: actionTypes.SAVE_NAME_ERROR, payload: e});
  }
  yield put({type: actionTypes.END_REQUEST});
}
